import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpErrorResponse ,HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable} from 'rxjs';
import { tap} from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { AuthService } from './auth-service.component';
import { EnvService } from './env.service';
import { SpinnerService } from './loader/spinner.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  env: EnvService;
  progress:any;

  constructor(private _authService: AuthService, public _env: EnvService,
            public spinnerService: SpinnerService,private _router: Router) {
    this.env = _env;
  }

  //here we intercep every request add access token and show spinner every request
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //so far this is our solution when uploading so progress bar will work on iexplorer...
    if (req.url.startsWith(this._env.apiWebResolution+'WebResInvoice/UploadWebResFile?invoiceIds')) {
      return from(this._authService.getAccessToken()).pipe(
        switchMap(token => {
            const headers = req.headers
                .set('Authorization', 'Bearer ' + token)
            const reqClone = req.clone({
                headers
            });
          return next.handle(reqClone);
      }));
    }

    if(!req.url.startsWith(this._env.apiTms + 'Shipment/GetCarrierQuoteAlert')){
      this.spinnerService.show();
    }

   //by default interceptor add content-type application/json since we are uploading we skip interceptor.
   //we put it as blacklisted.

    let json_blacklist = [];
    json_blacklist.push( this._env.apiWebResolution+'WebResInvoice/UploadWebResFile?invoiceIds')
    json_blacklist.push( this._env.apiWebstore+'Webstore/uploadDragDrop')
    json_blacklist.push( this._env.apiWebstore+'Webstore/uploadFileCTGF')
    json_blacklist.push( this._env.imageArchiveUri +'Document/GetWebResAttachmentOpenPDF?fle=')

    if (req.url.startsWith(this.env.apictgf)||req.url.startsWith(this.env.apiRateTrak)
                          ||req.url.startsWith(this.env.apiRoot) ||req.url.startsWith(this.env.apiWebResolution)
                          ||req.url.startsWith(this.env.imageArchiveUri) || req.url.startsWith(this.env.apiRateEngine) 
                          || req.url.startsWith(this.env.apiRule) || req.url.startsWith(this.env.apiWebstore) 
                          || req.url.startsWith(this.env.apiEdata) ||req.url.startsWith(this.env.apiTms) || req.url.startsWith(this.env.apiRateRequest)) {
      
      return from(this._authService.getAccessToken().then(token => {

        const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
        let headers;
        
        if(isIEOrEdge){ //ie cache every get so it will not refresh the new data 
          headers = new HttpHeaders().set('Authorization', `Bearer ${token}`)
          .set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache')
          .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
        }else{
          headers = new HttpHeaders().set('Authorization', `Bearer ${token}`)
        }
   
        const authReq = req.clone({ headers });
        return next.handle(authReq).pipe(
          tap(event => { 
            if (event instanceof HttpResponse) {
              this.spinnerService.hide()
            
            }
         }, error => {
          var respError = error as HttpErrorResponse;
          this.spinnerService.hide();
          if (respError && (respError.status === 401 || respError.status === 403)) {//todo: add error logic here
            if(respError.status === 401 ) {
              this._router.navigate(['/login'], { replaceUrl: true });

            }else if(respError.status === 403) {
              console.log(respError);
              console.log("unathroized should triger silent renew");
            }
          }
        })).toPromise();
      }));
    }
    else {
      this.spinnerService.hide();
      return next.handle(req);
    }
  }
}